<template>
        <v-autocomplete
            ref="searchInput"
            :disabled="disabled"
            :outlined="outlined"
            :error-messages="errorMessages"
            autocomplete="off"
            name="location-picker"
            :value="defaultValue || null"
            v-model="model"
            :items="items"
            :loading="isLoading"
            :search-input.sync="search"
            auto-select-first
            hide-no-data
            :hide-details="hideDetails"
            clearable
            @click:clear="clearSearch"
            @blur="onBlur"
            @keyup.enter="setManualModel"
            item-text="text"
            :filter="filter"
            :rules="rules"
            label="Dirección"
            :placeholder="placeholder"
            return-object
        >
            <template v-slot:prepend-inner="">
                <v-icon class="mr-1" v-if="prependIcon">{{prependIcon}}</v-icon>
            </template>
        </v-autocomplete>
</template>
<script>

    import {ApiUtils} from '@/utils/ApiUtils'
    import {debounce} from '@/utils/Common'

    export default{
        props:{
            defaultValue:{
                type: Object,
                default: () => { return {} }
            },
            hideDetails:{
                type: Boolean,
                default: true
            },
            errorMessages:{
                type: String,
                default: ''
            },
            placeholder:{
                type: String,
                default: 'Escribe una direccion'
            },
            googleApiKey:{
                type: String,
                default: process.env.VUE_APP_GMAPS_API_KEY
            },
            outlined: {
                type: Boolean,
                default: false
            },
            prependIcon: {
                type: String,
                default: ''
            },
            required: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            textLimit:{
                type: Number,
                default: 50
            }
        },
        mounted(){
            var vm = this

            if(!vm.defaultValue || Object.keys(vm.defaultValue).length === 0){

                return
            }

            const defaultModel = JSON.parse(JSON.stringify(vm.defaultModel))

            vm.model = defaultModel
            setTimeout(function(){
                vm.search = defaultModel.address.full
            }, 300)

        },
        data: (vm) => ({
            entries: [],
            isLoading: false,
            isQueryLoading: false,
            geoCodingEndpoint: 'https://maps.googleapis.com/maps/api/geocode',
            model: null,
            search: '',
            lastSearchText: ''
        }),
        methods: {
            resetValidation(){
              const vm = this
              vm.$refs.searchInput.resetValidation()
            },
            clearSearch(){
                this.model = null
                this.search = ''
                this.lastSearchText = ''
                this.entries = []
                this.isLoading = false
            },
            manualModel(value){
                const text = (value || '').trim()
                if(!text) return null
                return {
                    text: text,
                    address: {full: text},
                    location: null,
                    manual: true
                }
            },
            setManualModel(){
                const vm = this
                const manualModel = vm.manualModel(vm.search || vm.lastSearchText)
                if(!manualModel) return
                if(
                    vm.model &&
                    vm.model.address &&
                    vm.model.address.full &&
                    vm.model.address.full.toLowerCase() === manualModel.address.full.toLowerCase()
                ) return
                vm.model = manualModel
            },
            setManualModelForTerm(term){
                const vm = this
                const currentSearch = (vm.search || '').trim()
                if(currentSearch.toLowerCase() !== term.toLowerCase()) return

                const manualModel = vm.manualModel(term)
                if(!manualModel) return
                if(
                    vm.model &&
                    vm.model.address &&
                    vm.model.address.full &&
                    vm.model.address.full.toLowerCase() === manualModel.address.full.toLowerCase()
                ) return

                vm.model = manualModel
                vm.search = manualModel.address.full
            },
            onBlur(){
                this.setManualModel()
                this.$emit('blur')
            },
            filter(item, queryText, itemText){
                return true;
            },
            debouncedSearch: debounce(function(){
                this.searchAddress()
            }, 300),


            async searchAddress(){

                var vm = this
                var term = (this.search || '').trim()
                if(!term || term.length < 3) {
                    vm.isLoading = false
                    vm.entries = []
                    return
                }
                vm.selectedAddress = ''
                var query = `region=cl&components=country:CL&address=${encodeURIComponent(term)}&key=${vm.googleApiKey}`

                try{
                    vm.isQueryLoading = true
                    const response = await fetch(`${vm.geoCodingEndpoint}/json?${query}`)
                    if(response.ok){
                        const json = await response.json()
                        this.entries = json.results
                        if(!this.entries.length) vm.setManualModelForTerm(term)
                        return
                    }

                    this.entries = []
                    vm.setManualModelForTerm(term)
                } catch (error) {
                    this.entries = []
                    vm.setManualModelForTerm(term)
                } finally {
                    vm.isQueryLoading = false
                    vm.isLoading = false
                }

            },
        },
        computed: {
            defaultModel(){
                var vm = this
                return {
                    text: vm.defaultValue && vm.defaultValue.text || '',
                    address: {
                        full: vm.defaultValue && vm.defaultValue.text || ''
                    },
                    location: vm.defaultValue && vm.defaultValue.location || null,
                }
            },
            rules(){
                var vm = this
                return !vm.required ? [] : [
                    v => !!v || 'Campo obligatorio'
                ]
            },
            items () {
                return this.entries.map(entry => {

                    const { address_components, formatted_address, geometry } = entry

                    const street = address_components.find(component => component.types.includes('route'))
                    const number = address_components.find(component => component.types.includes('street_number'))
                    const commune = address_components.find(component => component.types.includes('administrative_area_level_3'))
                    const province = address_components.find(component => component.types.includes('administrative_area_level_2'))
                    const region = address_components.find(component => component.types.includes('administrative_area_level_1'))
                    const country = address_components.find(component => component.types.includes('country'))

                    const text = formatted_address

                    const body = {
                        full: formatted_address,
                        street: street && street.long_name || '',
                        number: number && number.long_name || '',
                        commune: commune && commune.long_name || '',
                        province: province && province.long_name || '',
                        region: region && region.long_name || '',
                        country: country && country.long_name || '',
                    }

                    return {
                        text: text,
                        address: body,
                        location: geometry.location
                    }

                })
            },
        },

        watch: {
            search (val, oldVal) {

                var vm = this


                if(val === oldVal) {
                    this.isLoading = false
                    return
                }

                if(val === null || val === undefined) {
                    this.isLoading = false
                    return
                }

                if(val.trim()){
                    vm.lastSearchText = val.trim()
                }

                if(vm.model && val === vm.model.address.full) {
                    this.isLoading = false
                    return
                }

                if(!vm.model && val === '') {
                    this.isLoading = false
                    return
                }

                if(val === ''){
                    this.isLoading = false
                    vm.entries = []
                    vm.model = null
                    return
                }

                if(vm.model && vm.model.address && vm.model.address.full && (
                    vm.model.address.full.toLowerCase() !== val.toLowerCase()
                )){
                    vm.model = null
                }

                if(val.trim().length < 3){
                    this.isLoading = false
                    vm.entries = []
                    return
                }

                vm.isLoading = true
                vm.debouncedSearch()

            },
            model(val, oldVal){
                var vm = this
                vm.$emit('change', val)
            }
        },
    }
</script>

<style scoped>
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active,
    textarea:-webkit-autofill,
    textarea:-webkit-autofill:hover,
    textarea:-webkit-autofill:focus,
    textarea:-webkit-autofill:active,
    select:-webkit-autofill,
    select:-webkit-autofill:hover,
    select:-webkit-autofill:focus,
    select:-webkit-autofill:active {
        transition-delay: 99999s;
        -webkit-transition-delay: 99999s;
    }
</style>
